import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SessaoUtil } from '../util/sessao-util';
import { Funcionalidade } from '../util/enum/funcionalidade.enum';
import { Modo } from '../util/enum/modo.enum';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(private router: Router,
                private sessaoUtil: SessaoUtil) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        // Primeiramente verifica se o usuário está logado, se não tiver redireciona para login
        if (!localStorage.getItem('nfceapi_dadosSessao')) {
            this.router.navigate(['/login'], { queryParams: { returnUrl: state.url }});
            return false;
        }

        let usuarioAdministrador: Boolean = route.data['usuarioAdministrador'];

        if(usuarioAdministrador != null && usuarioAdministrador){
          if(!this.sessaoUtil.isUsuarioAdministrador()){
            this.sessaoUtil.toasterUtil.info('Acesso permitido somente as usuários administradores.');
            return false;
          }
        }

        // Verificando permissão se tiver acessando uma rotina legada, apenas elas possuem o parâmetro viewId
        let funcionalidade: Funcionalidade = route.data['funcionalidade'];

        if(funcionalidade == undefined || funcionalidade == null){
          return false;
        }

        let modo: Modo = route.data['modo'];

        if(modo == undefined || modo == null){
          if (!this.sessaoUtil.possuiPermissao(funcionalidade)) {
            this.sessaoUtil.toasterUtil.info('Acesso não permitido para esta rotina.');
            return false;
          }
        }else{
          if(Modo.CONSULTA === modo){
            if (!this.sessaoUtil.possuiPermissao(funcionalidade)) {
              this.sessaoUtil.toasterUtil.info('Acesso não permitido para esta rotina.');
              return false;
            }
          }else{
            if (!this.sessaoUtil.possuiPermissaoTotal(funcionalidade)) {
              this.sessaoUtil.toasterUtil.info('Acesso não permitido para esta rotina.');
              return false;
            }
          }
        }

        return true;
    }
}



// WEBPACK FOOTER //
// ./src/app/auth/auth.guard.ts